<template>
  <div>
    <h3 class="is-size-5">Area</h3>
    <hr>
    <b-columns v-if="agentEvacuation.length > 0">
      <b-column>
        <b-table
          :data="agentEvacuation"
          :columns="columns"
        />
      </b-column>
    </b-columns>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['agentEvacuation']),
  },
  data () {
    return {
      columns: [
        {
          field: 'guide',
          label: 'Instructions'
        },
        {
          field: 'zone_radius_meters',
          label: 'Radius (m)'
        },
        {
          field: 'guide_pdf',
          label: 'PDF Guide'
        }
      ]
    }
  }
}
</script>
